import {
  SUMSUB_TYPE_PREFIX,
  SUMSUB_ON_APPLICANT_STATUS_CHANGED,
} from "@/pages/quiz/base/questions/sumsubAttachmentBlock/common";
import { VerifySsnSubmitted } from "@/api/vouched/types";

export interface SsnBlockAnswer {
  passed: boolean;
  method: "ssn" | "sumsub";
}

export type SumsubBlockAnswer =  SsnBlockAnswer | null;

export enum SumsubBlockState {
  // State 1: collect the last 4 digits of the user's SSN
  SSN_LAST_4 = "ssnLast4",
  // State: name/date-of-birth mismatch — ask the user to recheck their data
  MISMATCH = "mismatch",
  // State: too many failed verify attempts — hand off to the photo-ID flow
  HANDOFF = "handoff",
  // State: Sumsub photo-ID + selfie verification flow
  SUMSUB = "sumsub",
}

// Which banner the correction screen shows.
export enum MismatchReason {
  DETAILS = "details",
  INVALID_PHONE = "invalidPhone",
}

// The values the verification was performed with (used to prefill the form).
export interface MismatchInfo {
  submitted?: VerifySsnSubmitted;
  reason: MismatchReason;
}

export enum ReviewStatus {
  Completed = "completed",
}

export enum SumsubEvent {
  OnApplicantStatusChanged = `${SUMSUB_TYPE_PREFIX}.${SUMSUB_ON_APPLICANT_STATUS_CHANGED}`,
}

export enum ReviewAnswer {
  RED = "RED",
  GREEN = "GREEN",
}

export interface SumsubResult {
  token?: string;
  verified?: boolean;
}

export interface MessagePayload {
  applicantId?: string;
  reviewStatus?: ReviewStatus;
  reviewResult?: { reviewAnswer: string };
}

export enum ErrorReason {
  CAMERA_PERMISSION_DENIED = "permissionsDenied",
  NO_TOKEN = "noToken",
}

export interface ErrorData {
  code: string;
  reason: ErrorReason;
  error: string;
}
